module.exports = __webpack_public_path__ + "static/media/june.2ccaa763.jpeg";